import { AHV13 } from "ahv13-validator";

const ahv13validator = new AHV13();

export const isValidAVSNumber = (input: string) => {
    if (!input) {
        return false;
    }
    return input.startsWith("756") && ahv13validator.isValid(input);
};
